import pq1Img1 from '../../Assets/pqImg1.jpg';
import pq1Img2 from '../../Assets/pqImg2.jpg';
import pq1Img3 from '../../Assets/pqImg3.jpg';

const pullQuotesData = [
  {
    number: 1,
    quote:
      '“Enterprises are looking for data-center-class high availability and usability but something that can run on very small and efficient devices outside of the core data center.”',
    author: '— Julian Chesterfield | CEO and Co-Founder of Sunlight.io',
    image: pq1Img1
  },
  {
    number: 2,
    quote:
      '“The feedback we’re getting is that operations are running much more smoothly [...] The staff is much happier because they’re not getting whiplash being pulled in ten different directions.”',
    author: '— George Shaw | CEO and Founder of Pathr.ai',
    image: pq1Img2
  },
  {
    number: 3,
    quote:
      '“We provide access to our AI labs in Raleigh, Stuttgart, Beijing, and Taipei [...] The goal is to find the most efficient ways for these partners to reach the next level. We spend a lot of effort in the first mile—all the pre-testing, documentation—and the last mile, including deployment and supply chain.”',
    author: '— Nicholas Borsotto | AI Innovators Program Lead',
    image: pq1Img3
  }
];

export default pullQuotesData;
